import { convertLatexToMathMl } from "mathlive";

function latexToMathML(latex) {
  if (!latex) return "";

  // if (!window.MathJax) {
  //   return;
  // }

  // return window.MathJax.tex2mml(latex, { display: false });
  return convertLatexToMathMl(latex);
}

function cleanLatex(latex) {
  if (!latex) return "";

  return latex.replace(/^\$(.*)\$$/, "$1").trim();
}

export { latexToMathML, cleanLatex };
